import { Record, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export const SECURITIES_REDUCER_KEY = 'securitiesStore';

export const SecurityTypeEnum = Object.freeze({
  STOCK: 'STOCK',
  MUTUALFUND: 'MUTUALFUND',
  SWEEP: 'SWEEP',
  DEBT: 'DEBT',
  OPTION: 'OPTION',
  BOND: 'BOND',
  CRYPTOCURRENCY: 'CRYPTOCURRENCY',
  OTHER: 'OTHER',
});

export type SecurityType = keyof typeof SecurityTypeEnum;

export type SecurityProps = {
  id?: string;
  clientId?: string;
  isDeleted?: boolean;
  createdAt?: string;
  modifiedAt?: string;
  ownerId?: string;
  securityId?: string;
  securityIdType?: string;
  name?: string;
  symbol?: string;
  securityType?: SecurityType;
  currentUnitPrice?: number;
};
export type Security = RecordOf<SecurityProps>;

// PUT - replace entire resource
export const mkSecurity = Record<SecurityProps>({
  id: undefined,
  clientId: undefined,
  isDeleted: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  ownerId: undefined, // dataset id - need to hide it in QCS?
  securityId: undefined,
  securityIdType: 'CLIENT_ID',
  name: '',
  symbol: '',
  securityType: SecurityTypeEnum.OTHER,
  currentUnitPrice: 0,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [SECURITIES_REDUCER_KEY]: QcsSyncResourceStore<SecurityProps>;
  }
}
